// extracted by mini-css-extract-plugin
module.exports = {"suggestion":"_10c3ca76","suggestionTitle":"_2b0f1736"};